'use strict'
import api from '../../utils/api'
import moment from 'moment';
import * as types from '../constants/ActionTypes'
import { decrypt } from '../../utils/index';

import {message} from 'antd'

let getLatestReportFinish = (report) => {
    if (report.errCode == 0) {
        return {
            type: types.GET_LATEST_REPORT_FINISH,
            payload: {
                result: report.encryptData ? decrypt(report.encryptData) : report.result,
            }
        }
    } else {
        return {
            type: types.GET_LATEST_REPORT_FINISH,
            payload: {},
            error: true
        }
    }
}

let getHistoryReportsFinish = (carNumber, report) => {
    if (report.errCode == 0) {
        return {
            type: types.GET_HISTORY_REPORT_FINISH,
            payload: {
                carNumber: carNumber,
                results: report.result
            }
        }
    } else {
        return {
            type: types.GET_HISTORY_REPORT_FINISH,
            payload: {carNumber},
            error: true
        }
    }
}

let getLatestReport = (flowId, agentId) => {
    if (!flowId) {
        return
    }
    var url = '/lossAss/getReportInfo/' + flowId + '?agentId=' + agentId
    return dispatch => {
        return api(url).get()
            .then((report) => dispatch(getLatestReportFinish(report))).catch(err => {

            })
    }
}

let getHistoryReports = (data,reportsList) => {
    const {agentId, pageIndex, pageSize, orderBy, order, state, subState, searchStr,channel, hasLeaveMsg, isVideoSurvey, searchDate, flag} = data
    let beginTime = '';
    let endTime = '';
    if (searchDate == 'yesterday') {
        beginTime = moment(moment().subtract(1, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    } else if (searchDate == 'last7days') {
        beginTime = moment(moment().subtract(7, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    } else if (searchDate == 'last30days') {
        beginTime = moment(moment().subtract(30, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    }
    var url = '/lossAss/getHistoryReports/' + agentId + '?pageSize=' + pageSize + '&pageIndex=' + pageIndex
    if(beginTime)url +='&beginTime=' + beginTime
    if(endTime)url +='&endTime=' + endTime
    if(orderBy)url +='&orderBy=' + orderBy
    if(order)url +='&order=' +order
    if(state && state!='all')url +='&state=' + state
    // hack
    // 保存工单字状态筛选项
    if(subState && subState!='all') {
        url +='&subState=' + subState
    } else if (state === 'finished') {
        // reportSubStates
        let subStates = sessionStorage.getItem('reportSubStates');
        if(subStates) url +='&subState=' + subStates;
    }
    if(searchStr)url +='&searchStr=' + searchStr
    if(channel)url +='&channel=' + channel
    if(isVideoSurvey)url +='&isVideoSurvey=' + isVideoSurvey
    if (hasLeaveMsg && hasLeaveMsg != 'all') url += '&hasLeaveMsg=' + hasLeaveMsg
    url +='&flag=' + flag
    if(data.return)url +='&clientReview=' + data.return

    if(data.majorCaseType)url +='&majorCaseType=' + data.majorCaseType
    if(data.isLostContactCsr!==undefined)url +='&isLostContactCsr=' + data.isLostContactCsr
    if(data.coopTaskTypes&& data.coopTaskTypes.length > 0)url +='&coopTaskTypes=' + data.coopTaskTypes.join()
    if(data.complaintLevels)url +='&complaintLevels=' + data.complaintLevels.join()


    if(data.hasNewImg!==undefined)url +='&hasNewImg=' + data.hasNewImg

    if(data.searchType!==undefined)url +='&searchType=' + data.searchType

    if(data.kwType!==undefined)url +='&kwType=' + data.kwType

    if (data.riskLevelId && data.riskLevelId.length > 0) {

        url += '&riskLevelId=' + data.riskLevelId.join()
    }
    return dispatch => {
        return api(url).get()
            .then((report) =>dispatch(getReportListClassify_finish( report,flag, state ,reportsList)))
            .catch(err => dispatch(getReportListClassify_finish({errCode: -1})))
    }
}

let getHistoryDefLossTasks = (data,reportsList) => {
    const {agentId, pageIndex, pageSize, orderBy, order, defLossState, defLossSubState, searchStr,channel, hasLeaveMsg, isVideoSurvey, searchDate, flag} = data
    let beginTime = '';
    let endTime = '';
    if (searchDate == 'yesterday') {
        beginTime = moment(moment().subtract(1, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    } else if (searchDate == 'last7days') {
        beginTime = moment(moment().subtract(7, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    } else if (searchDate == 'last30days') {
        beginTime = moment(moment().subtract(30, 'days').format('YYYY-MM-DD')).format('X')
        endTime = moment(moment().format("YYYY-MM-DD")).format('X')
    }
    var url = '/lossAss/getHistoryDefLossTasks/' + agentId + '?pageSize=' + pageSize + '&pageIndex=' + pageIndex
    if(beginTime)url +='&beginTime=' + beginTime
    if(endTime)url +='&endTime=' + endTime
    if(orderBy)url +='&orderBy=' + orderBy
    if(order)url +='&order=' +order
    if(defLossState && defLossState!='all') url +='&defLossState=' + defLossState
    // hack
    // 查询定损任务定损中状态的工单，需要取出之前保存的 子状态
    if(defLossSubState) {
        url +='&defLossSubState=' + defLossSubState
    } else if (defLossState === 'checking') {
        const defLossSubState = sessionStorage.getItem('defLossTaskSubStates');
        if (defLossSubState) url +='&defLossSubState=' + defLossSubState
    }
    if(searchStr)url +='&searchStr=' + searchStr
    if(channel)url +='&channel=' + channel
    if(isVideoSurvey)url +='&isVideoSurvey=' + isVideoSurvey
    if (hasLeaveMsg && hasLeaveMsg != 'all') url += '&hasLeaveMsg=' + hasLeaveMsg
    url +='&flag=' + flag
    if (data.return) {
        url +='&clientReview=' +data.return
    }
    if(data.majorCaseType)url +='&majorCaseType=' + data.majorCaseType

    if(data.isLostContactCsr!==undefined)url +='&isLostContactCsr=' + data.isLostContactCsr

    if(data.coopTaskTypes&& data.coopTaskTypes.length > 0) url +='&coopTaskTypes=' + data.coopTaskTypes.join()
    if(data.complaintLevels) url +='&complaintLevels=' + data.complaintLevels.join()

    if(data.hasNewImg!==undefined)url +='&hasNewImg=' + data.hasNewImg

    if(data.kwType!==undefined)url +='&kwType=' + data.kwType

    if(data.searchType!==undefined)url +='&searchType=' + data.searchType
    if (data.riskLevelId && data.riskLevelId.length > 0) {

        url += '&riskLevelId=' + data.riskLevelId.join()
    }

    
  
    return dispatch => {
        return api(url).get()
            .then((report) =>dispatch(getReportListClassify_finish( report,flag, defLossState ,reportsList)))
            .catch(err => dispatch(getReportListClassify_finish({errCode: -1})))
    }
}
let getReportListClassify_finish=(data,flag,state,reportsListData)=>{

    if(data.errCode==0){
        let result = data.result || {}
        let params = result.params || {}
        let dateNum = new Date().valueOf()
        let stateObj = result.stateObj
        if(reportsListData){
            let reportsList ={}
            let stateList = ['untreated','unhold','assigned','checking','checked','holdedOn','surveied','offline','returned','finished', 'claiming', 'claimReturned', 'tocheck','all']
            _.forEach(stateList,(value)=>{
                reportsList[value]={}
                if(value == state){
                    reportsList[value]['pageIndex'] =params.pageIndex
                    reportsList[value]['pageSize'] =params.pageSize
                    reportsList[value]['orderBy'] =params.orderBy
                    reportsList[value]['order'] =params.order
                    reportsList[value]['channel'] =params.channel
                    reportsList[value]['searchStr'] =params.searchStr
                    reportsList[value]['count']=stateObj[value] || 0
                    reportsList[value]['state']=value
                    reportsList[value]['lastUpdataTime']=dateNum
                    reportsList[value]['list']=result.list
                }else{
                    reportsList[value]['pageIndex'] =reportsListData[value]['pageIndex']
                    reportsList[value]['pageSize'] =reportsListData[value]['pageSize']
                    reportsList[value]['orderBy'] =reportsListData[value]['orderBy']
                    reportsList[value]['order'] =reportsListData[value]['order']
                    reportsList[value]['channel'] =reportsListData[value]['channel']
                    reportsList[value]['searchStr'] =reportsListData[value]['searchStr']
                    reportsList[value]['count']=stateObj[value] || 0
                    reportsList[value]['state']=value
                    reportsList[value]['lastUpdataTime']=''
                    reportsList[value]['list']=[]
                }

            })
            return{
                type:types.SEARCH_REPORT_LIST_CLASSIFY_SUCCESS,
                payload:reportsList,
            }
        }
        let searchOption = {
            pageIndex:params.pageIndex,
            pageSize:params.pageSize,
            orderBy:params.orderBy,
            order:params.order,
            channel:params.channel,
           // lastUpdataTime:dateNum,
            searchStr:params.searchStr||'',
        }

        if(flag){
            let reportsList ={}
            let stateList = ['untreated','unhold','assigned','checking','checked','holdedOn','surveied','offline','returned','finished','claiming', 'claimReturned', 'tocheck', 'all']
            _.forEach(stateList,(value)=>{
                reportsList[value]={...searchOption}
                reportsList[value]['count']=stateObj[value] || 0
                reportsList[value]['state']=value
                state==value?( reportsList[value]['lastUpdataTime']=dateNum):""
                state==value?( reportsList[value]['list']=result.list):( reportsList[value]['list']=[])
            })
            return {
                type:types.SEARCH_REPORT_LIST_CLASSIFY_SUCCESS,
                payload:reportsList,
            }
        }else{
            let stateReports ={...searchOption,state:state,list:result.list,count:result.count,lastUpdataTime:dateNum}

            return {
                type:types.GET_REPORT_LIST_CLASSIFY_SUCCESS,
                payload:stateReports,

            }
        }
    }else{
        return {
            type:types.GET_REPORT_LIST_CLASSIFY_FAILD,
            error:true
        }
    }
}


let setCurrentReport = (flowId) => {
    return {
        type: types.SET_CURRENT_REPORT,
        payload: {flowId}
    }
}


let changeActiveReportTab = (activeKey)=> {
    return {
        type: types.CHANGE_ACTIVE_REPORT_TAB,
        payload: {activeKey}
    }
}


let loadCustomerUploadImg = (imgData)=> {
    return {
        type: types.LOAD_CUSTOMER_UPLOAD_IMG,
        payload: {imgData}
    }
}

let createReport = (data)=> {
    let url = '/lossAss/newReport'
    return dispatch => {
        return api(url).post(data)
            .then((response) => dispatch(createReportFinish(response)))
            .catch(err => dispatch(createReportFinish({errCode: -1})))
    }
}

let createReportFinish = (response)=> {
    if (response.errCode == 0) {
        return {
            type: types.CREATE_REPORT_FINISH,
            payload: {
                report: response.result
            }
        }
    } else {
        return {
            type: types.CREATE_REPORT_FINISH,
            payload: {},
            error: true
        }
    }
}
let getCreateReport = (type)=> {
    return {
        type: types.GET_CREATE_REPORT_OR_DETAILE,
        payload: type
    }
}


let uploadNotification = (data)=> {
    return {
        type: types.UPLOAD_NOTIFICATION_FINISH,
        payload: {data}
    }
}

let showMeasure = (enhancement)=> {
    return {
        type: types.SHOW_MEASURE_FINISH,
        payload: {
            handelShowEnhance: enhancement
        }
    }
}

/**
 * 更改 补充图片  消息状态
 * @param data
 * @returns {Function}
 */
let changePhotoSupplementState = (data)=> {
    let url = '/lossAss/updateReport/' + data.flowId;
    let putData = {
        addPicsBusiness: data.addPicsBusiness
    }
    return dispatch=> {
        return api(url).put(putData)
            .then(result=>dispatch(changePhotoSupplementStateFinish(result)))
            .catch(err=>dispatch(changePhotoSupplementStateFinish({errCode: -1})))
    }
}
let changePhotoSupplementStateFinish = (result)=> {
    if (result.errCode == 0) {
        return {
            type: types.CHANGE_PHOTO_SUPPLEMENT_STATE_FINISH,
            payload: {}
        }
    } else {
        return {
            type: types.CHANGE_PHOTO_SUPPLEMENT_STATE_FINISH,
            payload: {},
            error: true
        }
    }
}


let changeDateRange = (dates) =>{
    return {
        type:types.CHANGE_DATE_RANGE,
        payload:dates
    }
}

let changeChannelType = (data) =>{
    return{
        type:types.CHANGE_CHANNEL_TYPE,
        payload:data
    }
}

let changeLeaveMsgType = (data) =>{
    return{
        type:types.CHANGE_HAS_LEAVE_MSG_TYPE,
        payload:data
    }
}
const changeSearchTypeParams = (data) =>{
    return{
        type:types.CHANGE_SEARCH_TYPE_PARAMS,
        payload: data
    }
}

const clearSearchParams = () => {
    return{
        type:types.CLEAR_SEARCH_PARAMS,
        payload: {}
    }
}

let changeVideoSurvey = (data) =>{
    return{
        type:types.CHANGE_VIDEO_SURVEY,
        payload:data
    }
}

let changeSearchInput = (value) =>{
    return{
        type:types.CHANGE_SEARCH_INPUT,
        payload:value
    }
}


let changeActiveReportTabs = (value) =>{
    return{
        type:types.CHANGE_ACTIVE_REPORT_TABLE_TABS,
        payload:value
    }
}

let getCurrentReport = (str, agentId) => {
    if (!str) {
        return
    }
    let url = '/lossAss/getReportInfo/' + str + '?from=agent' + (agentId ? '&agentId=' + agentId : '')
    return dispatch => {
        return api(url).get()
            .then((result) => {
                return dispatch(getCurrentReport_finish(result))
            }).catch(err => {

            })
    }
}
let getCurrentReport_finish=(data)=>{
    if(data&&data.errCode==0){
        return{
            type:types.GET_CURRENT_REPORT_FINISH,
            payload: data.encryptData ? decrypt(data.encryptData) : data.result
        }
    }else{
        message.info(data.errInfo);
    }
}

const updateCurrentReportFormData = (changedFields = {}) => {
    return dispatch => {
        return dispatch({
            type: types.UPDATE_REPORT_FORM_DATA,
            payload: changedFields,
        });
    }
}

const addOrReduceReportItems = (data) => {
    return dispatch => {
        return dispatch({
            type: types.ADD_OR_REDUCE_REPORT_ITEMS,
            payload: data,
        });
    }
}



export default {
    getLatestReport,
    getHistoryReports,
    getHistoryDefLossTasks,
    setCurrentReport,
    changeActiveReportTab,
    loadCustomerUploadImg,
    createReport,
    getCreateReport,
    uploadNotification,
    showMeasure,
    changePhotoSupplementState,
    changeDateRange,
    changeChannelType,
    changeLeaveMsgType,
    changeSearchTypeParams,
    clearSearchParams,
    changeVideoSurvey,
    changeSearchInput,
    changeActiveReportTabs,
    getCurrentReport,
    updateCurrentReportFormData,
    addOrReduceReportItems,
    getCurrentReport_finish
}
